import { KeyOf } from '~/types';
import { colors } from './colors';

export const themeColorLight = {
  main_1: '#3DF1F3',
  main_2: '#87D0D4',
  main_2_light: colors.blue800,
  main_2_dark: colors.blue800,
  main_2_tint: colors.blue800,
  main_2_border: colors.blue800,
  main_light: '#A9E5ED',
  main_dark: '#04435E',

  brand: colors.purple500,
  brand_light: colors.purple300,
  brand_dark: colors.purple600,
  brand_tint: colors.purple100,
  brand_border: colors.purple200,

  positive_light: colors.green300,
  positive_dark: colors.green600,
  positive_tint: colors.green100,
  positive_border: colors.green200,

  basic: colors.blackAlpha70,
  basic_light: colors.blackAlpha30,
  basic_dark: colors.blackAlpha90,
  basic_tint: colors.blackAlpha10,
  basic_border: colors.blackAlpha20,

  negative: colors.red500,
  negative2: colors.red250,
  negative_light: colors.red300,
  negative_dark: colors.red600,
  negative_tint: colors.red100,
  negative_border: colors.red200,

  always_basic: colors.whiteAlpha90,
} as const;

export const themeColorDark: ThemeColor = {
  main_1: '#3DF1F3',
  main_2: '#87D0D4',
  main_2_light: colors.blue800,
  main_2_dark: colors.blue800,
  main_2_tint: colors.blue800,
  main_2_border: colors.blue800,
  main_light: '#A9E5ED',
  main_dark: '#04435E',

  brand: colors.purple400,
  brand_light: colors.purple200,
  brand_dark: colors.purple500,
  brand_tint: colors.purple800,
  brand_border: colors.purple700,

  positive_light: colors.green200,
  positive_dark: colors.green500,
  positive_tint: colors.green800,
  positive_border: colors.green700,

  basic: colors.whiteAlpha90,
  basic_light: colors.white,
  basic_dark: colors.whiteAlpha40,
  basic_tint: colors.whiteAlpha10,
  basic_border: colors.whiteAlpha20,

  negative: colors.red400,
  negative2: colors.red250,
  negative_light: colors.red200,
  negative_dark: colors.red500,
  negative_tint: colors.red800,
  negative_border: colors.red700,

  always_basic: colors.whiteAlpha90,
};

export type ThemeColor = typeof themeColorLight;
export type ThemeColorKeys = KeyOf<typeof themeColorLight>;
